import { render, staticRenderFns } from "./FeePayment.vue?vue&type=template&id=afaaee74&"
import script from "./FeePayment.vue?vue&type=script&lang=js&"
export * from "./FeePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports